





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class AddTask extends Vue {
	@Prop()
	private list!: any

	@Prop()
	private orderNum!: any

	@Prop({
		default: '',
	})
	private span!: any
}
